export enum EnergietraegerType {
    SEE = 'SEE',
    SSE = 'SSE'
}

export class EnergietraegerTypeItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): EnergietraegerTypeItem[] {
        return [
            new EnergietraegerTypeItem(EnergietraegerType.SEE, 'SEE'),
            new EnergietraegerTypeItem(EnergietraegerType.SSE, 'SSE'),
        ];
    }

}
